// `uib-dropdown`, as a class name.
//
// ⚠️ A BOOTSTRAP DROPDOWN IS HIDDEN BY DEFAULT AND NOTHING IN THE MARKUP SAYS SO. The
// vendored `_dropdowns.scss` declares `.dropdown-menu { display: none }` and shows it only
// through `.open > .dropdown-menu { display: block }` — so a `<ul className="dropdown-menu">`
// rendered behind a React `open` flag is in the DOM, correct in every other respect, and
// invisible. There is no error, no empty box, nothing to inspect without opening the styles:
// the control simply does not respond.
//
// That cost three separate defects — the sort menu, the source selector and the bulk-action
// overflow — each reported as "does not open". Upstream never had to think about it because
// `uib-dropdown` puts the class on for you: the directive watches `isOpen` and adds `open` to
// the element carrying it. This is that directive, reduced to the one thing it does here.
//
// Two ways to get it wrong, both of which the SCSS will happily let you:
//
//   - the class goes on the PARENT of `.dropdown-menu`, not on the menu. The selector is a
//     CHILD combinator, so `.dropdown-menu.open` matches nothing.
//   - the parent must be the DIRECT parent. Hoisting the menu one level out — to escape an
//     `overflow: hidden`, say — silently re-hides it.
//
// `.actions-dropdown-caret` and `.bulk-actions-more-caret` both carry `&.open` rules in the
// ported stylesheets already, which is the other half of the same contract.

/** The container's class list, with `open` appended while the menu is showing. */
export function uibDropdown(base: string, open: boolean): string {
  return open ? `${base} open` : base
}
